<mat-accordion>
    <mat-expansion-panel [expanded]="$safeNavigationMigration(status()?.expanded)" [disabled]="disable" (afterExpand)="onExpand()"
        (afterCollapse)="onCollapse()">
        <mat-expansion-panel-header>
            @if (meta()?.title) {
            <mat-panel-title>
                @if (model()) {
                <input matInput [formControl]="titleControl" (focus)="onFocus()" (blur)="onBlur()" #titleInput
                    (change)="onChange($event)">
                }
                @if (!model()) {
                <span>{{meta().title}}</span>
                }
            </mat-panel-title>
            }
            @if (meta()?.description) {
            <mat-panel-description>{{meta().description}}</mat-panel-description>
            }
        </mat-expansion-panel-header>
        <ng-content></ng-content>
    </mat-expansion-panel>
</mat-accordion>
